import { UserAuthActionType, UserAuthActions } from './actions';

export type TwoFactorMethod = `email` | `sms`;

export type AuthStep = `login` | `methodSelector` | TwoFactorMethod;

export type UserIntent = {
  email: string;
  password: string;
  phone?: string;
};

export interface UserAuthState {
  authStep: AuthStep;
  userIntent: UserIntent;
  twoFactorMethods: TwoFactorMethod[];
}

export const getInitialState = (): UserAuthState => {
  return {
    authStep: `login`,
    userIntent: {
      email: ``,
      phone: ``,
      password: ``,
    },
    twoFactorMethods: [],
  };
};

export const UserAuthReducer = (state: UserAuthState, action: UserAuthActions): UserAuthState => {
  switch (action.type) {
    case UserAuthActionType.SET_USER_AUTH_STEP:
      return {
        ...state,
        authStep: action.payload.authStep,
      };
    case UserAuthActionType.SET_USER_INTENT:
      return {
        ...state,
        userIntent: action.payload.userIntent,
      };
    case UserAuthActionType.SET_2FA_METHODS:
      return {
        ...state,
        twoFactorMethods: action.payload.twoFactorMethods,
      };
    case UserAuthActionType.RESET_USER_AUTH:
      return getInitialState();
    default:
      return state;
  }
};
